import { DataLayer } from '@/shared/services/gtm/models/models-gtm'

export class PageViewDataLayer extends DataLayer {
    public page_name: string

    public constructor(params: { pageName: string; customerId?: string | null }) {
        super('page_view')

        this.page_name = params.pageName
        this.customerId = params.customerId
    }
}
